import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentDelete } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchDocumentDelete = createAsyncThunk(
    'sliderGet/fetchDocumentDelete',
    async ({ id }) => {
        const response = await DocumentDelete(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const documentDeleteSlice = createSlice({
    name: 'documentDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDocumentDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDocumentDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchDocumentDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default documentDeleteSlice.reducer;
